// Author

$('body').on('focus', '.events-search .author-menu-wrapper input', function() {
    var $this = $(this);
    var menu = $this.parents('.menu-wrapper');
    menu.addClass('opened');
    closeDropdown(menu.attr('data-dropdown'));
    return false;
});

$('body').on('keyup', '.events-search .author-menu-wrapper input', function() {
    var $this = $(this);

    $.ajax({
        type: 'POST',
        url: $this.attr('data-url'),
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
            _method: 'GET',
            search: $this.val()
        },
        dataType: 'json',
        success: function (data) {
            console.log(data);

            // empty the current donations
            $('.events-search .author-menu li').remove();

            $.each(data.authors, function(index, author) {
                $('.events-search .author-menu ul').append(`<li>
                    <a href="" class="select-author" data-author="${author.slug}">
                        <figure>
                            ${author.avatar_src ? `<img src="${author.avatar_src}" alt="author">` : `<figcaption>${author.initials}</figcaption>`}
                        </figure>

                        <span>${author.full_name}</span>
                    </a>
                </li>`);
            });
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
    
    return false;
});

$('body').on('click', '.events-search .select-author', function() {
    var $this = $(this);
    var menu = $this.parents('.menu-wrapper');

    menu.find('.selected-menu-item .menu-item').html($this.html());
    menu.addClass('selected');

    $('.events-search [name="author"]').val($this.attr('data-author'));
    closeDropdown();
    return false;
});

$('body').on('click', '.events-search .remove-author', function() {
    var $this = $(this);
    var menu = $this.parents('.menu-wrapper');

    menu.removeClass('selected');
    $('.events-search [name="author"]').val('');

    return false;
});


// Topic
$('body').on('focus', '.events-search .topic-menu-wrapper input', function() {
    var $this = $(this);
    var menu = $this.parents('.menu-wrapper');
    menu.addClass('opened');
    closeDropdown(menu.attr('data-dropdown'));
    return false;
});

$('body').on('keyup', '.events-search .topic-menu-wrapper input', function() {
    var $this = $(this);

    $.ajax({
        type: 'POST',
        url: $this.attr('data-url'),
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
            _method: 'GET',
            search: $this.val()
        },
        dataType: 'json',
        success: function (data) {
            console.log(data);

            // empty the current donations
            $('.events-search .topic-menu li').remove();

            $.each(data.topics, function(index, topic) {
                $('.events-search .topic-menu ul').append(`<li>
                    <a href="" class="select-topic" data-topic="${topic.slug}">
                        <span>${topic.title}</span>
                    </a>
                </li>`);
            });
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
    
    return false;
});

$('body').on('click', '.events-search .select-topic', function() {
    var $this = $(this);
    var menu = $this.parents('.menu-wrapper');

    menu.find('.selected-menu-item .menu-item').html($this.html());
    menu.addClass('selected');

    $('.events-search [name="topic"]').val($this.attr('data-topic'));
    closeDropdown();
    return false;
});

$('body').on('click', '.events-search .remove-topic', function() {
    var $this = $(this);
    var menu = $this.parents('.menu-wrapper');

    menu.removeClass('selected');
    $('.events-search [name="topic"]').val('');

    return false;
});